var _rect, _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.72,
    height: 55.46,
    rx: 4.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.22 3H5.5A2.5 2.5 0 0 0 3 5.47V50a2.47 2.47 0 0 0 2.49 2.47h44.72a2.5 2.5 0 0 0 2.5-2.47V5.47A2.47 2.47 0 0 0 50.22 3ZM20.4 10.42h4.97v4.94H20.4v-4.94Zm-4.96 34.62h-4.97V40.1h4.97v4.94Zm0-29.68h-4.97v-4.94h4.97v4.94Zm9.93 29.68H20.4V40.1h4.97v4.94Zm9.94 0h-4.97V40.1h4.97v4.94Zm-1-15.33-9.93 7.42a2.5 2.5 0 0 1-3.98-1.98V20.31a2.46 2.46 0 0 1 2.71-2.46c.46.04.9.2 1.27.48l9.94 7.42a2.48 2.48 0 0 1 0 3.96Zm1-14.35h-4.97v-4.94h4.97v4.94Zm9.94 29.68h-4.97V40.1h4.97v4.94Zm0-29.68h-4.97v-4.94h4.97v4.94Z",
    fill: "#CDD9E9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.02,
    cy: 47.08,
    rx: 12.98,
    ry: 12.92,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.58 45.94-1.47-.28a.63.63 0 0 1-.48-.4c-.07-.2-.15-.38-.24-.57a.63.63 0 0 1 .06-.63l.84-1.22a.68.68 0 0 0-.08-.87l-.9-.89a.68.68 0 0 0-.87-.08l-1.23.84a.64.64 0 0 1-.63.06 5.95 5.95 0 0 0-.57-.24.63.63 0 0 1-.4-.48l-.28-1.46a.68.68 0 0 0-.67-.56h-1.27a.69.69 0 0 0-.67.56l-.28 1.46a.63.63 0 0 1-.4.48c-.2.07-.39.15-.57.24a.64.64 0 0 1-.63-.06L46.6 41a.69.69 0 0 0-.87.08l-.9.9a.68.68 0 0 0-.08.86l.84 1.22a.63.63 0 0 1 .06.63l-.24.57a.63.63 0 0 1-.48.4l-1.47.28a.68.68 0 0 0-.56.67v1.26a.68.68 0 0 0 .56.67l1.47.27a.64.64 0 0 1 .48.4c.07.2.15.39.24.57a.63.63 0 0 1-.06.63l-.84 1.22a.68.68 0 0 0 .08.87l.9.9a.68.68 0 0 0 .87.07l1.23-.84a.64.64 0 0 1 .63-.05c.18.09.37.17.57.23a.63.63 0 0 1 .4.49l.28 1.46a.68.68 0 0 0 .67.55h1.27a.69.69 0 0 0 .67-.55l.27-1.46a.63.63 0 0 1 .41-.49c.2-.06.39-.14.57-.23a.64.64 0 0 1 .63.05l1.23.84a.69.69 0 0 0 .87-.08l.9-.89a.68.68 0 0 0 .08-.87l-.85-1.22a.63.63 0 0 1-.05-.63c.09-.18.17-.37.24-.57a.63.63 0 0 1 .48-.4l1.47-.27a.68.68 0 0 0 .55-.67V46.6a.68.68 0 0 0-.55-.67Zm-7.56 4.23a2.95 2.95 0 0 1-2.72-1.81 2.92 2.92 0 0 1 2.15-4 2.96 2.96 0 0 1 3.52 2.88 2.92 2.92 0 0 1-2.95 2.93Z",
    fill: "#5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoProcessing);
export default __webpack_public_path__ + "static/media/VideoProcessing.1f4d5eb3143cf7f479d54d0f07410c5b.svg";
export { ForwardRef as ReactComponent };